import React, {useEffect, useRef, useState} from 'react';
import s from './styles.module.css'
import {Button, Stack} from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import {ReactComponent as Hand} from "../../../assets/hand.svg";
import classNames from "classnames";
import {toast} from "react-toastify";
import api from "../../../api";
import {handleErrorConfirm} from "../../../utils/handlerError";

const Header = ({data, openModal, setData, headerData, disabled, current_sportsmen}) => {

    const handlerStop = async () => {
        const token = localStorage.getItem('token')
        try {
            const res = await api().get(`coach/hand/${token}`)

            if (res?.data?.status === 'error') {
                handleErrorConfirm(res?.data?.error || 'Ошибка')
                return
            }
            toast.success('Просьба о помощи отправлена', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } catch (e) {
            console.log(e)
            toast.error('Ошибка', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    }

    const handleNext = async (type) => {

        const token = localStorage.getItem('token');

        try {
            const move = await api().get(`coach/brigade/${type}/${token}`)
            if (move?.data?.status === 'last') {
                toast.error('Последний спортсмен')
            } else if (move?.data?.status === 'error') {
                toast.error(move?.data?.message || 'Ошибка')
            } else if (move?.data?.status === 'ok') {
                const res = await api().get(`coach/brigade/users/${token}`)
                setData(res?.data);
                setData({
                    ...data, users: res?.data.users.map((user) => user.is_processing_discipline_figure_id !== null ? ({
                        ...user, is_mark: 1
                    }) : ({
                        ...user, is_mark: null
                    }))
                });

            } else {
                toast.error('Ошибка')
            }

        } catch (e) {
            console.log(e)
        }
    }

    return (
        <div className={s.header}>
            <div className={s.left_header}>
                <div className={s.left_header_top}>
                    <div className={s.name_1}>
                        <Stack sx={{
                            maxWidth: '130px',
                            width: '130px',
                            minWidth: '130px',
                            display: 'inline-block',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                        }}>
                            {headerData?.couch_type_name_short || '...'}
                        </Stack>
                    </div>
                    <div className={s.name_2}>
                        <Stack sx={{
                            maxWidth: '100%',
                            display: 'inline-block',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                        }}>
                            {headerData?.competition_name || '...'}
                        </Stack>
                    </div>
                </div>
                <div className={s.left_header_bottom}>
                    <div className={s.name_3} style={{
                        justifyContent: 'center',
                        color: '#fff',
                        background: '#86B760',
                        borderRight: '1px solid #000'
                    }}>{current_sportsmen?.draw || '...'}</div>
                    <div className={s.name_5}>{`F-${headerData?.figure_number}` || '...'}</div>
                    <div className={s.name_5} style={{width:'300%'}}>
                        <Stack sx={{
                            maxWidth: '100%',
                            display: 'inline-block',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                        }}>
                            {headerData?.figure_name || '...'}
                        </Stack>
                    </div>
                    <div className={s.name_5}>
                        <Stack sx={{
                            maxWidth: '100%',
                            display: 'inline-block',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                        }}>
                            {`от ${headerData?.figure_start}` || '...'}
                        </Stack>
                    </div>

                    {/*<div className={s.action}>*/}
                    {/*    <div className={classNames(s.action_btn, s.action_btn_l)}*/}
                    {/*         onClick={() => handleNext('previous')}>{'<'}</div>*/}
                    {/*    <div className={classNames(s.action_btn, s.action_btn_r)}*/}
                    {/*         onClick={() => handleNext('next')}>{'>'}</div>*/}
                    {/*</div>*/}
                </div>
            </div>
            <div className={s.right_header}>
                <div className={s.hand} onClick={handlerStop}>
                    <Hand/>
                </div>
                <div className={classNames(s.btn)}>
                    <Button variant="contained" onClick={openModal} disabled={disabled} sx={{
                        height: '100%',
                        width: '100%'
                    }}>
                        <CheckIcon sx={{fontSize: 80}}/>
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Header;
